<div class="custom-expansion-panel" [ngClass]="{'is-expanded' : isExpanded}">
    <div class="expansion-panel-header" (click)="onHeaderClicked.emit()">
        <ng-content select="[header]"></ng-content>
        <i class="far fa-angle-down fa-lg"></i>
    </div>
    <div #panelBody class="custom-expansion-panel-body" [@expandCollapse]="isExpanded ? 'expanded' : 'collapsed'"
        (@expandCollapse.done)="onAnimationDone()">
        <ng-content select="[expandedContent]"></ng-content>
    </div>
</div>